export default {
  vendorBudget: {
    title: "Debug Fornitore-Budget",
    buttons: {
      testIntegration: "Testare Integrazione",
      testing: "Test in corso...",
      clear: "Cancellare",
    },
    errors: {
      noUserOrEvent: "❌ Nessun utente o evento selezionato",
      noUser: "❌ Nessun utente connesso",
      noEvent: "❌ Nessun evento selezionato",
      testError: "❌ Errore durante il test",
    },
    messages: {
      startTest: "🧪 Test completo dell'integrazione fornitore-budget...",
      initialState: "📊 Stato iniziale delle spese...",
      initialFound: "Iniziale: {{count}} spese trovate",
      creatingVendor: "👨‍💼 Creazione di un fornitore ingaggiato con prezzo...",
      vendorData: "Dati fornitore: {{data}}",
      vendorCreated: "✅ Fornitore creato con ID: {{id}}",
      waitingExpenses: "⏳ Attesa della creazione delle spese...",
      checkingExpenses: "📊 Verifica delle spese dopo la creazione del fornitore...",
      afterCreation: "Dopo creazione: {{count}} spese trovate",
      vendorExpenses: "Spese del fornitore: {{count}}",
      expenseDetail: "{{index}}. {{title}}: {{amount}}€ (pagato: {{paid}})",
      checkingIds: "🔍 Verifica degli ID delle spese nel fornitore...",
      vendorFound: "Fornitore trovato: {{name}}",
      expenseId: "ID spesa: {{id}}",
      depositExpenseId: "ID deposito: {{id}}",
      notDefined: "non definito",
      vendorNotFound: "❌ Fornitore non trovato dopo la creazione",
      cleanup: "🧹 Pulizia: eliminazione del fornitore di test...",
      vendorDeleted: "✅ Fornitore di test eliminato",
      finalCheck: "📊 Verifica finale delle spese...",
      finalCount: "Finale: {{count}} spese trovate",
      cleanupSuccess: "✅ Pulizia riuscita: tutte le spese di test sono state eliminate",
      cleanupWarning: "⚠️ Attenzione: alcune spese di test potrebbero persistere",
    },
    noLogs: "Nessun log per ora...",
  },
  contactsApi: {
    title: "Test dell'API Contact Picker",
    browser: "Browser",
    https: "HTTPS",
    apiStatus: "API Contact Picker",
    enabled: "Abilitato",
    disabled: "Disabilitato",
    supported: "Supportato",
    notSupported: "Non supportato",
    technicalDetails: "Dettagli tecnici",
    userAgent: "User Agent",
    platform: "Piattaforma",
    language: "Lingua",
    cookiesEnabled: "Cookie abilitati",
    yes: "Sì",
    no: "No",
    testButton: "Testare accesso ai contatti",
    testing: "Test in corso...",
    error: "Errore",
    contactsRetrieved: "Contatti recuperati ({{count}})",
    noName: "Senza nome",
    recommendations: "Raccomandazioni",
    recommendation1: "• Usare Chrome su Android o Safari su iOS per migliori risultati",
    recommendation2: "• Assicurarsi che il sito sia in HTTPS",
    recommendation3: "• Permettere l'accesso ai contatti quando richiesto",
    recommendation4: "• Questa API funziona solo su mobile nella maggior parte dei casi",
    errors: {
      notSupported: "L'API Contact Picker non è supportata su questo browser",
      unknown: "Errore sconosciuto nell'accesso ai contatti",
    },
    browserDetection: {
      chromeMobile: "Chrome Mobile",
      safariMobile: "Safari Mobile",
      chromeDesktop: "Chrome Desktop",
      safariDesktop: "Safari Desktop",
      firefox: "Firefox",
      edge: "Edge",
      unknown: "Browser sconosciuto",
    },
  },
}; 